import axios from "axios";
import VueCookies from "vue-cookies";

const instance = axios.create();

const access_token = VueCookies.get("user_access_token");

if (access_token) {
  instance.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
}

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((prom) => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });
//   failedQueue = [];
// };

// instance.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     const originalRequest = error.config;
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         return new Promise(function (resolve, reject) {
//           failedQueue.push({ resolve, reject });
//         })
//           .then((token) => {
//             originalRequest.headers["Authorization"] = "Bearer " + token;
//             return instance(originalRequest);
//           })
//           .catch((err) => {
//             return Promise.reject(err);
//           });
//       }
//       originalRequest._retry = true;
//       isRefreshing = true;
//       return new Promise(function (resolve, reject) {
//         instance
//           .post(`${oAuthEndPoint}?apiType=atom-apis`)
//           .then(({ data: { access_token } }) => {
//             VueCookies.set(
//               "user_access_token",
//               access_token,
//               addYears(new Date(), 1),
//               "/"
//             );
//             instance.defaults.headers.common[
//               "Authorization"
//             ] = `Bearer ${access_token}`;
//             originalRequest.headers["Authorization"] = `Bearer ${access_token}`;
//             processQueue(null, access_token);
//             resolve(instance(originalRequest));
//           })
//           .catch((err) => {
//             processQueue(err, null);
//             reject(err);
//           })
//           .then(() => {
//             isRefreshing = false;
//           });
//       });
//     }
//     return Promise.reject(error);
//   }
// );

export const createInstance = axios.create;
export default instance;
